import {useState} from "react";
import moment from "moment";
import {
  Card, Table, Stack, TableRow, TableBody, TableCell, Container, Typography,
  TableContainer, Select, TextField, FormControl, InputLabel, MenuItem,
  Grid, Chip, CircularProgress, Button,
} from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import MyPagination from "src/components/common/MyPagination";
import {asyncRequest} from "src/services/network";
import {alert} from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import UserInfoDrawer from "src/components/common/UserInfoDrawer";

const TABLE_HEAD = [
  {id: "id", label: "ID", alignRight: false},
  {id: "uid", label: "用户", alignRight: false},
  {id: "action", label: "操作类型", alignRight: false},
  {id: "joinType", label: "加入方式", alignRight: false},
  {id: "days", label: "天数", alignRight: false},
  {id: "prevEndTime", label: "操作前到期", alignRight: false},
  {id: "newEndTime", label: "操作后到期", alignRight: false},
  {id: "adminName", label: "操作人", alignRight: false},
  {id: "remark", label: "备注", alignRight: false},
  {id: "createdAt", label: "操作时间", alignRight: false},
];

const ACTION_OPTIONS = [
  {value: "", label: "全部"},
  {value: "GRANT", label: "开通"},
  {value: "EXTEND", label: "延期"},
  {value: "REVOKE", label: "撤销"},
];

const JOIN_TYPE_OPTIONS = [
  {value: "", label: "全部"},
  {value: "ADMIN", label: "后台拨付"},
  {value: "PAYMENT", label: "充值购买"},
];

const ACTION_MAP = {GRANT: "开通", EXTEND: "延期", REVOKE: "撤销"};
const ACTION_COLOR_MAP = {GRANT: "success", EXTEND: "info", REVOKE: "error"};
const JOIN_TYPE_MAP = {ADMIN: "后台拨付", PAYMENT: "充值购买"};

function formatTime(ts) {
  if (!ts) return "-";
  return moment(ts).format("YYYY-MM-DD HH:mm:ss");
}

export default function JytVipLog() {
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [hasQueried, setHasQueried] = useState(false);
  const [filter, setFilter] = useState({
    page: 0, size: 20, uid: "", action: "", joinType: "", startDate: "", endDate: "",
  });

  // 用户详情弹框
  const [targetUser, setTargetUser] = useState(null);

  async function getItems(filterOverride) {
    setItems(null);
    const queryFilter = filterOverride || filter;
    const {data, count} = await asyncRequest({
      path: "/jingxi/jyt-vip/log",
      data: queryFilter,
    });
    setItems(data || []);
    setTotal(count);
    setHasQueried(true);
  }

  const handlePageChange = (event, value, newSize) => {
    let newFilter;
    if (newSize !== undefined) {
      newFilter = {...filter, page: 0, size: newSize};
    } else {
      const newPage = value - 1;
      if (newPage === filter.page) return;
      newFilter = {...filter, page: newPage};
    }
    setFilter(newFilter);
    if (hasQueried) getItems(newFilter);
  };

  function handleReset() {
    setHasQueried(false);
    setItems(null);
    setTotal(0);
    setFilter({page: 0, size: 20, uid: "", action: "", joinType: "", startDate: "", endDate: ""});
  }

  async function handleExport() {
    const {msg} = await asyncRequest({
      path: "/jingxi/jyt-vip/log/export",
      data: filter,
    });
    alert(msg, "success");
  }

  const isNotFound = items && items.length === 0;

  return (
    <Page title="金银通VIP开通日志">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            金银通VIP开通日志
          </Typography>
        </Stack>

        <Card>
          <ListToolbar showSearch={false} onReset={handleReset} onRefresh={() => getItems()}>
            <Grid container rowGap={2} alignItems="center">
              <Grid item sm={6} md={3}>
                <TextField
                  size="small" style={{width: 200}} label="鲸世优选UID"
                  placeholder="输入UID" autoComplete="off"
                  value={filter.uid} onChange={(e) => setFilter({...filter, uid: e.target.value})}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>操作类型</InputLabel>
                  <Select label="操作类型" value={filter.action}
                    onChange={(e) => setFilter({...filter, action: e.target.value})} style={{width: 200}}>
                    {ACTION_OPTIONS.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>加入方式</InputLabel>
                  <Select label="加入方式" value={filter.joinType}
                    onChange={(e) => setFilter({...filter, joinType: e.target.value})} style={{width: 200}}>
                    {JOIN_TYPE_OPTIONS.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small" style={{width: 200}} label="开始日期"
                  placeholder="YYYY-MM-DD" autoComplete="off"
                  value={filter.startDate} onChange={(e) => setFilter({...filter, startDate: e.target.value})}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small" style={{width: 200}} label="结束日期"
                  placeholder="YYYY-MM-DD" autoComplete="off"
                  value={filter.endDate} onChange={(e) => setFilter({...filter, endDate: e.target.value})}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <Stack direction="row" spacing={1}>
                  <Button variant="contained" size="small" onClick={() => getItems()}>查询</Button>
                  <Button variant="outlined" size="small" onClick={handleExport} disabled={!hasQueried}>导出</Button>
                </Stack>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{minWidth: 1200}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                {!hasQueried ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Stack sx={{width: "100%", height: 200}} alignItems="center" justifyContent="center">
                          <Typography variant="body2" color="text.secondary">请设置查询条件后点击查询</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : !items ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <Stack sx={{width: "100%", height: 200}} alignItems="center" justifyContent="center">
                          <CircularProgress/>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {items.map((row) => (
                      <TableRow hover key={row.id} tabIndex={-1}>
                        <TableCell align="left">{row.id}</TableCell>
                        <TableCell align="left">
                          <UserInfo uid={row.uid} nickname={row.nickname} onClick={() => setTargetUser({uid: row.uid})}/>
                        </TableCell>
                        <TableCell align="left">
                          <Chip size="small" label={ACTION_MAP[row.action] || row.action} color={ACTION_COLOR_MAP[row.action] || "default"}/>
                        </TableCell>
                        <TableCell align="left">{JOIN_TYPE_MAP[row.joinType] || row.joinType}</TableCell>
                        <TableCell align="left">{row.days}天</TableCell>
                        <TableCell align="left">{formatTime(row.prevEndTime)}</TableCell>
                        <TableCell align="left">{formatTime(row.newEndTime)}</TableCell>
                        <TableCell align="left">{row.adminName || row.addUid || "-"}</TableCell>
                        <TableCell align="left">{row.remark || "-"}</TableCell>
                        <TableCell align="left">{formatTime(row.createdAt)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{py: 5}}><SearchNotFound/></TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}/>
        </Card>
      </Container>

      {/* 用户详情弹框 */}
      {targetUser && (
        <UserInfoDrawer
          open
          uid={targetUser.uid}
          onClose={() => setTargetUser(null)}
        />
      )}
    </Page>
  );
}
